import {
  createAction
} from 'redux-actions';

import { HUB_CONNECTION_STATE } from '../const/paymentKiosk';

export const SET_HUB_CONNECTION_STATE = 'SET_HUB_CONNECTION_STATE';

export const setHubConnectionState = createAction(SET_HUB_CONNECTION_STATE, hubConnectionState => hubConnectionState);

export const ID_SCAN_BEGIN = 'ID_SCAN_BEGIN';
export const ID_SCAN_REQUEST = 'ID_SCAN_REQUEST';
export const ID_SCAN_CANCEL = 'ID_SCAN_CANCEL';
export const ID_SCAN_END = 'ID_SCAN_END';
export const ID_SCAN_RESPONSE = 'ID_SCAN_RESPONSE';
export const ID_SCAN_ERROR = 'ID_SCAN_ERROR';

export const beginIdScan = createAction(ID_SCAN_BEGIN);
export const requestIdScan = createAction(ID_SCAN_REQUEST);
export const cancelIdScan = createAction(ID_SCAN_CANCEL);
export const endIdScan = createAction(ID_SCAN_END);
export const responseIdScan = createAction(ID_SCAN_RESPONSE, scanResponse => scanResponse);
export const setErrorIdScan = createAction(ID_SCAN_ERROR, scanError => scanError);

export const SET_PAYMENT_KIOSK_SETTINGS = 'SET_PAYMENT_KIOSK_SETTINGS';

export const setPaymentKioskSettings = createAction(SET_PAYMENT_KIOSK_SETTINGS, kioskSettings => kioskSettings);

export const SET_HANDLE_ORDERS_AFTER_LOGIN = 'SET_HANDLE_ORDERS_AFTER_LOGIN';

export const setHandleOrdersAfterLogin = createAction(SET_HANDLE_ORDERS_AFTER_LOGIN, shouldHandleOrders => shouldHandleOrders);

const initialState = {
  kioskSettings: {
    kioskId: null
  },
  idScan: {
    isInError: false,
    isActive: false
  },
  loginForm: {
    shouldHandleOrders: false
  },
  hubConnection: {
    connectionState: HUB_CONNECTION_STATE.DISCONNECTED
  }
};

const paymentKioskReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HUB_CONNECTION_STATE:
      return {
        ...state,
        hubConnection: {
          connectionState: action.payload
        }
      };

    case ID_SCAN_BEGIN:
      return {
        ...state,
        idScan: {
          ...state.idScan,
          isInError: false,
          isActive: true
        }
      };

    case ID_SCAN_END:
      return {
        ...state,
        idScan: {
          ...state.idScan,
          isInError: false,
          isActive: false
        }
      };

    case ID_SCAN_ERROR:
      return {
        ...state,
        idScan: {
          ...state.idScan,
          isInError: action.payload
        }
      };

    case SET_PAYMENT_KIOSK_SETTINGS:
      return {
        ...state,
        kioskSettings: {
          ...state.kioskSettings,
          ...action.payload
        }
      };

    case SET_HANDLE_ORDERS_AFTER_LOGIN:
      return {
        ...state,
        loginForm: {
          shouldHandleOrders: action.payload
        }
      };

    default:
      return state;
  }
}

export default paymentKioskReducer;


// WEBPACK FOOTER //
// ./src/reducers/paymentKioskReducer.js